// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-exportButton-module__btn--QAsyO {
  background-color: #faa718;
  color: #ffffff;
  border: none;
  padding: 5px 15px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  font-family: inherit;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.src-js-pages-usageReportingContainer-components-exportButton-module__btn--QAsyO:hover {
  opacity: 0.85;
}

.src-js-pages-usageReportingContainer-components-exportButton-module__btn--QAsyO:active {
  opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/exportButton.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".btn {\n  background-color: #faa718;\n  color: #ffffff;\n  border: none;\n  padding: 5px 15px;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-family: inherit;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.btn:hover {\n  opacity: 0.85;\n}\n\n.btn:active {\n  opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `src-js-pages-usageReportingContainer-components-exportButton-module__btn--QAsyO`
};
export default ___CSS_LOADER_EXPORT___;
